"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPaymentInfoCommand = void 0;
class AddPaymentInfoCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, currency, contents } = this.input;
        const { fbq: facebookQueue } = config;
        const object = {
            value: value,
            currency: currency,
            contents: contents,
        };
        facebookQueue('track', 'AddPaymentInfo', object);
        facebookQueue('trackCustom', 'AddPaymentWeb', object);
        return Promise.resolve();
    }
}
exports.AddPaymentInfoCommand = AddPaymentInfoCommand;
